export const OPEN = 'modal/OPEN'
export const CLOSE = 'modal/CLOSE'
export const CONTINUE = 'modal/CONTINUE'
export const CONTINUE_TO_PATHNAME = 'modal/CONTINUE_TO_PATHNAME'
export const CLEAR_PATHNAME = 'modal/CLEAR_PATHNAME'
export const LOGIN_PATHNAME = 'modal/LOGIN_PATHNAME'
